import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumb = () => {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);
  
  if (pathParts.length <= 1) return null; // Don't show on home page
  
  const currentLang = pathParts[0] === 'de' ? 'de' : 'en';
  
  const pageNames = {
    en: {
      productions: 'Productions',
      pricing: 'Pricing',
      contact: 'Contact',
      blog: 'Blog',
      impressum: 'Impressum',
      thankyou: 'Thank You',
    },
    de: {
      productions: 'Produktionen',
      pricing: 'Preise',
      contact: 'Kontakt',
      blog: 'Blog',
      impressum: 'Impressum',
      danke: 'Danke',
    }
  };

  const breadcrumbs = [
    { name: currentLang === 'de' ? 'Startseite' : 'Home', path: `/${currentLang}` }
  ];

  if (pathParts.length > 1) {
    const pagePath = pathParts[1];
    const pageName = pageNames[currentLang][pagePath] || pagePath;
    breadcrumbs.push({ name: pageName, path: `/${currentLang}/${pagePath}` });
  }

  return (
    <nav aria-label="Breadcrumb" className="bg-gray-50 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <ol 
          className="flex items-center gap-2 text-sm"
          itemScope 
          itemType="https://schema.org/BreadcrumbList"
        >
          {breadcrumbs.map((crumb, index) => (
            <li 
              key={crumb.path}
              className="flex items-center gap-2"
              itemProp="itemListElement" 
              itemScope 
              itemType="https://schema.org/ListItem"
            >
              {index === 0 && <Home className="w-4 h-4 text-gray-400" aria-hidden="true" />}
              {index > 0 && <ChevronRight className="w-4 h-4 text-gray-400" aria-hidden="true" />}
              {index === breadcrumbs.length - 1 ? (
                <span 
                  className="text-gray-900 font-medium"
                  itemProp="name"
                  aria-current="page"
                >
                  {crumb.name}
                </span>
              ) : (
                <Link 
                  to={crumb.path}
                  className="text-gray-600 hover:text-gray-900 transition-colors"
                  itemProp="item"
                >
                  <span itemProp="name">{crumb.name}</span>
                </Link>
              )}
              <meta itemProp="position" content={String(index + 1)} />
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;
